import { LayoutDashboard, Receipt, CreditCard, Wallet, BarChart3, MessageSquare, UserCircle } from 'lucide-react';
import type { Group } from '@/components/layout/GroupedLayout';
import type { NavItem } from '@/components/layout/RoleLayout';

/**
 * Bursar menu, the same dropdown sections as the school owner's, in the order money moves:
 * set fees → bill → collect → check → spend → report. `gate` is the key the owner uses to switch a page off.
 */
export const bursarGroups: Group[] = [
  { key: 'overview', section: 'Overview', icon: LayoutDashboard, items: [
    { to: 'dashboard', label: 'Dashboard' },
    { to: 'approvals', label: 'Payment requests', gate: 'wallet' },
  ] },
  { key: 'fees', section: 'Fees & billing', icon: Receipt, items: [
    { to: 'fee-structure', label: 'Fee structures', gate: 'fees' },
    { to: 'fee-heads', label: 'Fee heads', gate: 'fees' },
    { to: 'discounts', label: 'Discounts & sibling rule', gate: 'fees', also: ['fee-discounts'] },
    { to: 'invoices', label: 'Invoices', gate: 'invoices' },
    { to: 'debtors', label: 'Debtors & reminders', gate: 'debtors' },
  ] },
  { key: 'collect', section: 'Collections', icon: CreditCard, items: [
    { to: 'record-payment', label: 'Collect a payment', gate: 'collect' },
    { to: 'payments', label: 'All payments', gate: 'collect' },
    { to: 'receipts', label: 'Receipts', gate: 'collect' },
    { to: 'reconciliation', label: 'Reconciliation', gate: 'reconciliation' },
  ] },
  { key: 'out', section: 'Money out', icon: Wallet, items: [
    { to: 'wallet', label: 'School wallet & transfers', gate: 'wallet' },
    { to: 'bank-accounts', label: 'Bank accounts', gate: 'bank-accounts' },
    { to: 'withdrawals', label: 'Withdrawals', gate: 'withdrawals' },
    { to: 'expenses', label: 'Expenses', gate: 'expenses' },
    { to: 'payroll', label: 'Payroll & salaries', gate: 'payroll' },
    { to: 'stock', label: 'Store & stock', gate: 'stock' },
  ] },
  { key: 'reports', section: 'Reports', icon: BarChart3, items: [
    { to: 'books', label: 'Books (ledger, budget, P&L)', gate: 'books' },
    { to: 'reports', label: 'Finance reports', gate: 'reports' },
    { to: 'audit-log', label: 'Finance audit log' },
  ] },
  { key: 'help', section: 'Communication', icon: MessageSquare, items: [
    { to: 'notices', label: 'Notices & SMS', gate: 'notices' },
    { to: 'messages', label: 'Messages' },
    { to: 'support', label: 'OJP support' },
  ] },
  { key: 'me', section: 'Me', icon: UserCircle, items: [
    { to: 'clock-in', label: 'Clock in (scan)' },
    { to: 'my-pay', label: 'My pay' },
    { to: 'notifications', label: 'Notifications' },
    { to: 'account', label: 'Account' },
  ] },
];

/** Older flat list, kept for anything that still imports it. */
export const nav: NavItem[] = bursarGroups.flatMap((g) => g.items.map((i) => ({ to: i.to, label: i.label, icon: g.icon, group: g.section })));
